/**
 * App config – announcement banner (text, visible). Read-only on client.
 */
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const ANNOUNCEMENT_PATH = 'appConfig/announcement';

export function subscribeAnnouncement(onUpdate) {
  const ref = doc(db, ANNOUNCEMENT_PATH);
  return onSnapshot(
    ref,
    (snap) => {
      if (!snap.exists()) {
        onUpdate({ text: '', visible: false });
        return;
      }
      const d = snap.data();
      onUpdate({
        text: typeof d.text === 'string' ? d.text : '',
        visible: d.visible === true,
      });
    },
    () => onUpdate({ text: '', visible: false })
  );
}
